// components/ui/FeatureCard.jsx
import React from 'react';
import { Card, Typography, Box, Icon } from '@mui/material';

export const FeatureCard = ({ icon, title, description, gradient = false }) => {
  return (
    <Card 
      hover 
      glow={gradient}
      sx={{
        p: 3,
        height: '100%',
        background: gradient 
          ? 'linear-gradient(135deg, #8b0000 0%, #1a1f3d 100%)'
          : 'linear-gradient(135deg, rgba(26, 31, 61, 0.8) 0%, rgba(10, 17, 40, 0.9) 100%)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
          height: '100%',
        }}
      >
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            background: 'linear-gradient(45deg, #8b0000, #ff4d4d)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            animation: 'float 3s ease-in-out infinite',
          }}
        >
          <Icon sx={{ fontSize: 30, color: 'white' }}>{icon}</Icon>
        </Box>
        
        <Typography variant="h6" gutterBottom sx={{ color: 'white', fontWeight: 600 }}>
          {title}
        </Typography>
        
        <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.8)', flexGrow: 1 }}>
          {description}
        </Typography>
      </Box>
    </Card>
  );
};



